(function () {
  'use strict';

  var KEY = 'iglu_compare_v1';
  var MAX = 4;

  /* DEMO REZIMAS (aktyvuojant visiems - istrinti si bloka iki pabaigos zymos) */
  var DEMO_KEY = 'iglu_compare_demo';
  try {
    var qs = new URLSearchParams(location.search);
    if (qs.get('palyginimas-demo') === '1') localStorage.setItem(DEMO_KEY, '1');
    if (qs.get('palyginimas-demo') === '0') localStorage.removeItem(DEMO_KEY);
    if (localStorage.getItem(DEMO_KEY) === '1') {
      document.documentElement.classList.add('compare-demo');
    }
  } catch (e) { /* privatus rezimas */ }
  /* DEMO REZIMO pabaiga */

  var root = '/';
  var rootEl = document.getElementById('compare-bar') || document.getElementById('compare-app');
  if (rootEl && rootEl.dataset.root) root = rootEl.dataset.root;
  if (root.slice(-1) !== '/') root += '/';
  var isEN = root.indexOf('/en') === 0;
  var isPL = root.indexOf('/pl') === 0;
  var isDE = root.indexOf('/de') === 0;

  var T = isEN
    ? {
        bar: 'Compare',
        clear: 'Clear',
        remove: 'Remove',
        view: 'View product',
        price: 'Price',
        availability: 'Availability',
        inStock: 'In stock',
        outStock: 'Sold out',
        empty: 'Select at least two products to compare – click the compare button on any product card.',
        max: 'You can compare up to ' + MAX + ' products.',
        error: 'Could not load product data. Please try again.'
      }
    : isPL
    ? {
        bar: 'Porównaj',
        clear: 'Wyczyść',
        remove: 'Usuń',
        view: 'Zobacz produkt',
        price: 'Cena',
        availability: 'Dostępność',
        inStock: 'Dostępny',
        outStock: 'Wyprzedany',
        empty: 'Wybierz co najmniej dwa produkty do porównania – kliknij przycisk porównania na karcie produktu.',
        max: 'Porównać można maksymalnie ' + MAX + ' produktów.',
        error: 'Nie udało się wczytać danych produktów. Spróbuj ponownie.'
      }
    : isDE
    ? {
        bar: 'Vergleichen',
        clear: 'Leeren',
        remove: 'Entfernen',
        view: 'Produkt ansehen',
        price: 'Preis',
        availability: 'Verfügbarkeit',
        inStock: 'Auf Lager',
        outStock: 'Ausverkauft',
        empty: 'Wählen Sie mindestens zwei Produkte zum Vergleich – klicken Sie auf der Produktkarte auf die Vergleichsschaltfläche.',
        max: 'Sie können bis zu ' + MAX + ' Produkte vergleichen.',
        error: 'Die Produktdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.'
      }
    : {
        bar: 'Palyginti',
        clear: 'Išvalyti',
        remove: 'Pašalinti',
        view: 'Peržiūrėti prekę',
        price: 'Kaina',
        availability: 'Prekyboje',
        inStock: 'Yra',
        outStock: 'Išparduota',
        empty: 'Pasirinkite bent dvi prekes palyginimui – spauskite palyginimo mygtuką prekės kortelėje.',
        max: 'Palyginti galima iki ' + MAX + ' prekių.',
        error: 'Nepavyko įkelti prekių duomenų. Pabandykite dar kartą.'
      };

  function load() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      if (!Array.isArray(v)) return [];
      return v.map(function (x) {
        return typeof x === 'string' ? { h: x, id: null } : x;
      }).filter(function (x) { return x && x.h; });
    } catch (e) {
      return [];
    }
  }

  function findIndex(list, handle, id) {
    for (var i = 0; i < list.length; i++) {
      if (id && list[i].id && String(list[i].id) === String(id)) return i;
      if (list[i].h === handle) return i;
    }
    return -1;
  }

  function save(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* privatus rezimas */
    }
    syncToggles();
    renderBar();
  }

  function toggleHandle(handle, id, type) {
    var list = load();
    var i = findIndex(list, handle, id);
    if (i >= 0) {
      list.splice(i, 1);
    } else {
      /* Palyginimas tik toje pacioje kategorijoje (Irmanto pageidavimu):
         pridedant preke, paliekam tik tos pacios kategorijos elementus
         (kitos kategorijos ar be tipo - pasalinam, pradedam nauja palyginima). */
      if (type) {
        var same = list.filter(function (x) { return x.t === type; });
        if (same.length !== list.length) list = same;
      }
      if (list.length >= MAX) {
        var bar = document.getElementById('compare-bar');
        if (bar) {
          bar.classList.add('compare-bar--shake');
          setTimeout(function () { bar.classList.remove('compare-bar--shake'); }, 500);
        }
        return;
      }
      list.push({ h: handle, id: id || null, t: type || null });
    }
    save(list);
  }

  function syncToggles() {
    var list = load();
    var toggles = document.querySelectorAll('.compare-toggle[data-handle]');
    for (var i = 0; i < toggles.length; i++) {
      var on = findIndex(list, toggles[i].dataset.handle, toggles[i].dataset.id) >= 0;
      toggles[i].classList.toggle('is-active', on);
      toggles[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function renderBar() {
    var bar = document.getElementById('compare-bar');
    if (!bar) return;
    if (document.getElementById('compare-app')) {
      bar.hidden = true;
      return;
    }
    var list = load();
    if (list.length === 0) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;
    var link = bar.querySelector('.compare-bar__link');
    if (link) {
      link.textContent = T.bar + ' (' + list.length + ')';
      link.classList.toggle('compare-bar__link--disabled', list.length < 2);
    }
    var clear = bar.querySelector('.compare-bar__clear');
    if (clear) clear.textContent = T.clear;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.compare-toggle[data-handle]') : null;
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      toggleHandle(btn.dataset.handle, btn.dataset.id, btn.dataset.type);
      return;
    }
    var clear = e.target.closest ? e.target.closest('.compare-bar__clear') : null;
    if (clear) {
      e.preventDefault();
      save([]);
      if (document.getElementById('compare-app')) renderApp();
    }
  });

  /* --- Palyginimo puslapis --- */

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function fetchProduct(handle) {
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=compare-json')
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      })
      .then(function (t) { return JSON.parse(t); })
      .catch(function () { return null; });
  }

  function parseSpecs(text) {
    var out = [];
    if (!text) return out;
    var lines = String(text).split('\n');
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();
      if (!line) continue;
      var idx = line.indexOf(':');
      if (idx <= 0) continue;
      out.push([line.slice(0, idx).trim(), line.slice(idx + 1).trim()]);
    }
    return out;
  }

  function urlList() {
    try {
      var p = new URLSearchParams(location.search).get('p');
      if (!p) return null;
      var out = p.split(',').map(function (h) {
        return { h: h.trim(), id: null };
      }).filter(function (x) { return x.h; });
      return out.length ? out : null;
    } catch (e) {
      return null;
    }
  }

  function renderApp() {
    var app = document.getElementById('compare-app');
    if (!app) return;
    var list = urlList() || load();
    if (list.length === 0) {
      app.innerHTML = '<p class="compare-empty">' + esc(T.empty) + '</p>';
      return;
    }
    app.innerHTML = '<div class="compare-loading"></div>';
    Promise.all(list.map(function (entry) {
      return fetchProduct(entry.h).then(function (data) {
        if (data) data.storedHandle = entry.h;
        return data;
      });
    })).then(function (products) {
      products = products.filter(Boolean);
      var seen = {};
      products = products.filter(function (p) {
        var k = String(p.id || p.storedHandle);
        if (seen[k]) return false;
        seen[k] = true;
        return true;
      });
      if (products.length === 0) {
        app.innerHTML = '<p class="compare-empty">' + esc(T.error) + '</p>';
        return;
      }

      var specMaps = products.map(function (p) {
        var m = {};
        parseSpecs(p.specs).forEach(function (kv) { m[kv[0]] = kv[1]; });
        return m;
      });
      var labels = [];
      products.forEach(function (p) {
        parseSpecs(p.specs).forEach(function (kv) {
          if (labels.indexOf(kv[0]) < 0) labels.push(kv[0]);
        });
      });

      var html = '<div class="compare-table-wrapper"><table class="compare-table"><thead><tr>';
      html += '<th class="compare-table__label-col" aria-hidden="true"></th>';
      products.forEach(function (p) {
        html += '<th class="compare-table__product">';
        html += '<button type="button" class="compare-table__remove" data-remove="' + esc(p.storedHandle) + '" aria-label="' + esc(T.remove) + '">&times;</button>';
        if (p.image) html += '<a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy"></a>';
        html += '<a class="compare-table__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>';
        html += '<a class="compare-table__cta button" href="' + esc(p.url) + '">' + esc(T.view) + '</a>';
        html += '</th>';
      });
      html += '</tr></thead><tbody>';

      html += '<tr><th scope="row">' + esc(T.price) + '</th>';
      products.forEach(function (p) {
        html += '<td><strong>' + esc(p.price) + '</strong>';
        if (p.compareAtPrice) html += ' <s>' + esc(p.compareAtPrice) + '</s>';
        html += '</td>';
      });
      html += '</tr>';

      html += '<tr><th scope="row">' + esc(T.availability) + '</th>';
      products.forEach(function (p) {
        html += '<td>' + esc(p.available ? T.inStock : T.outStock) + '</td>';
      });
      html += '</tr>';

      labels.forEach(function (label) {
        html += '<tr><th scope="row">' + esc(label) + '</th>';
        specMaps.forEach(function (m) {
          html += '<td>' + (m[label] ? esc(m[label]) : '<span class="compare-table__na">–</span>') + '</td>';
        });
        html += '</tr>';
      });

      html += '</tbody></table></div>';
      html += '<p class="compare-note">' + esc(T.max) + '</p>';
      app.innerHTML = html;

      var removes = app.querySelectorAll('[data-remove]');
      for (var i = 0; i < removes.length; i++) {
        removes[i].addEventListener('click', function () {
          var l = load();
          var j = findIndex(l, this.dataset.remove, null);
          if (j >= 0) l.splice(j, 1);
          save(l);
          renderApp();
        });
      }
    });
  }

  function init() {
    syncToggles();
    renderBar();
    renderApp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* korteles, ikeltos veliau (infinite scroll, quick view) - debounce, kad nekrautu DOM */
  var syncTimer = null;
  new MutationObserver(function () {
    if (syncTimer) return;
    syncTimer = setTimeout(function () { syncTimer = null; syncToggles(); }, 300);
  }).observe(document.body, { childList: true, subtree: true });
})();
